module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/item/item.component.css
// module id = ./src/app/item/item.component.css
// module chunks = main